import styled from 'styled-components';

import THEME from '../../../../../constants/theme';

export const Container = styled.div`
  color: ${THEME.bobBlack};
  font-size: 14px;
  font-weight: 500;
`;
